import { render, staticRenderFns } from "./seurantajakso-kouluttaja-vastuuhenkilo.vue?vue&type=template&id=7b1f462a&scoped=true&"
import script from "./seurantajakso-kouluttaja-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./seurantajakso-kouluttaja-vastuuhenkilo.vue?vue&type=script&lang=ts&"
import style0 from "./seurantajakso-kouluttaja-vastuuhenkilo.vue?vue&type=style&index=0&id=7b1f462a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1f462a",
  null
  
)

export default component.exports